/**
 * POST /lesson-bookings — book teaching time with an instructor, as the
 * authenticated member. [BUT-843, ours]
 *
 * Identity comes from the token — `userId` must never appear in `body`.
 * `X-Client-App` is set unconditionally by `lib/apiClient/utils/headers.ts`
 * from `constants.ts` `CLIENT_INFO.APP: 'web-portal-2'`, and the server maps
 * that to the booking's `source: 'web'`. The ticket text says
 * `X-Client-App: mobile-app` because it was written mobile-first — on this
 * surface the correct value is the app's own, and it is not something the
 * client code sets or should override.
 *
 * @module lessons/api/createLessonBooking
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { CreateLessonBookingRequest, CreateLessonBookingResponse } from '../types';

export function createLessonBooking(
  body: CreateLessonBookingRequest,
  ctx: { clubId: number; tenantHandle: string },
): Promise<ApiResult<CreateLessonBookingResponse>> {
  return apiClient.post<CreateLessonBookingResponse>('/lesson-bookings', body, {
    clubId: ctx.clubId,
    tenantHandle: ctx.tenantHandle,
    // The payment step renders the refusal itself, beside the form.
    showErrorToast: false,
    // Never auto-retry a booking, the rule `bookingService.createBooking`
    // states for the standard flow. A request that timed out may still have
    // committed: the retry then finds the bay taken — by the member's own
    // booking — and reports a conflict for a lesson that was booked and charged.
    retries: 0,
  });
}
